import React from "react";
import CustomerListTable from "../../components/table/all-tables/customerlisttable/CustomerListTable";
import ComponentViewFallback from "../../components/error-boundary/fallback/ComponentViewFallback";
import ErrorBoundary from "../../components/error-boundary";

const Customers = () => (
  <ErrorBoundary fallback={<ComponentViewFallback />}>
    <div className="customer-listing-wrap mt-5">
      <div className="row">
        <div className="col-12">
          <div className="customer-listing-table">
            <CustomerListTable />
          </div>
        </div>
      </div>
    </div>
  </ErrorBoundary>
);

export default Customers;
